import { render, staticRenderFns } from "./vehicle-detail-page-footer.vue?vue&type=template&id=586653f6&"
import script from "./vehicle-detail-page-footer.vue?vue&type=script&lang=js&"
export * from "./vehicle-detail-page-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports